import styles from './style.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

// This reference container provides a base structure, but may not be used / needs to be completed
class BaseContainer extends CustomComponent {
   constructor() {
      super();
      this.customStyle = styles;
   }

   render() {
      const element = document.createElement('div');
      element.classList.add(`base-grid`);
      element.innerHTML = `
           <slot></slot>
      `;
      return element;
   }

}

customElements.define('nxt-base-container', BaseContainer);
